<template>
  <div class="image-uploader">
    <v-img
      contain
      class="image-area rounded fill-height"
      :width="suggestedWidth"
      :height="suggestedHeight"
      v-if="!hasPreviewUrl">
      <template>
        <div class="placeholder fill-height" v-if="!hasPreviewUrl">
          <label class="label">{{suggestedWidth}}x{{suggestedHeight}}</label>
        </div>
      </template>
    </v-img>
    <v-img
      v-bind="attributes"
      v-else
      contain
      class=" rounded fill-height"
      :src="previewUrl"
      :lazy-src="previewUrl">
      <template>
        <div class="placeholder fill-height" v-if="!hasPreviewUrl">
          <label class="label">{{suggestedWidth}}x{{suggestedHeight}}</label>
        </div>
      </template>
    </v-img>
    <v-btn text color="primary" class="text-capitalize mt-2" @click="$refs.file.click()">{{ uploadLabel }}</v-btn>
    <input
      @change="onChange"
      accept=".jpg, .jpeg, .png"
      ref="file"
      style="display: none"
      type="file"
    />

  </div>
</template>
<script>
import get from 'lodash/get'

export default {
  props: {
    suggestedWidth: {
      type: String,
      default: '100'
    },
    suggestedHeight: {
      type: String,
      default: '100'
    },
    uploadLabel: {
      type: String,
      default: 'Upload'
    },
    value: {
      type: [String, Object, File],
      default () {
        return null
      }
    }
  },
  computed: {
    attributes () {
      return {
        ...this.$attrs
      }
    },
    previewUrl () {
      if (this.value instanceof File) {
        return URL.createObjectURL(new File([this.value], this.value.name))
      }

      if (this.value instanceof Object) {
        return get(this.value, 'url')
      }

      return ''
    },
    hasPreviewUrl () {
      return this.previewUrl !== null && this.previewUrl !== ''
    }
  },
  methods: {
    onChange (e) {
      this.$emit('input', e.target.files[0])
    }
  }
}
</script>
<style scoped>
.image-uploader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.image-area {
  border: 2px dashed #d8d8d8;
}
.image-uploader .placeholder{
  min-height: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5px;
  color: #bbbbbb;
}

.placeholder .label{
  font-size: 12px;
}
</style>
